<template>
  <div>
    <div class="d-flex">
      <v-layout row wrap>
        <v-flex xs12 sm11>
          <h1 class="text-xs-center">Action Log</h1>
        </v-flex>
        <v-flex xs12 sm1>
          <div class="text-xs-right">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn flat icon color="black" v-on="on">
                  <v-icon>mdi-filter-menu</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile
                  v-for="(item, index) in items"
                  :key="index"
                  @click="select(item)"
                >
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <v-card class="mt-3">
      <business_log :searchLog="filler" />
    </v-card>
  </div>
</template>

<script>
import business_log from "@/components/back-office/Business/Business-log.vue";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
export default {
  data() {
    return {
      expand2: false,
      items: [
        { title: "Pending", status: "1" },
        { title: "Approve", status: "2" },
        { title: "Reject", status: "3" },
        { title: "Delete", status: "4" },
        { title: "Edit docs", status: "5" },
      ],
      filler: {},
    };
  },
  computed: {
    ...mapState({
      businessListData: (state) => state.Business.businessListData,
    }),
  },
  components: {
    business_log,
  },
  methods: {
    async select(item) {
      this.filler = item;
    },
  },
};
</script>
